(function () {
  // --- helpers ---
  function parseMedia(slider) {
    const raw = slider.getAttribute("data-media") || "";
    return raw.split("|").map(s => s.trim()).filter(Boolean);
  }

  function getIndex(slider) {
    const v = Number(slider.getAttribute("data-index") || "0");
    return Number.isFinite(v) ? v : 0;
  }

  function setIndex(slider, i) {
    slider.setAttribute("data-index", String(i));
  }

  function setImg(img, url) {
    if (!img || !url) return;
    const current = img.getAttribute("src") || "";
    if (current === url) return;

    img.classList.add("is-changing");
    window.setTimeout(() => {
      img.setAttribute("src", url);
      img.classList.remove("is-changing");
    }, 90);
  }

  function stopAll(e) {
    if (!e) return;
    e.preventDefault?.();
    e.stopPropagation?.();
    e.stopImmediatePropagation?.();
    return false;
  }

  function goNext(slider) {
    const urls = parseMedia(slider);
    const img = slider.querySelector(".dr-card-slider__img");
    if (!img || urls.length <= 1) return;

    let i = getIndex(slider);
    i = (i + 1) % urls.length;
    setIndex(slider, i);
    setImg(img, urls[i]);
  }

  function goPrev(slider) {
    const urls = parseMedia(slider);
    const img = slider.querySelector(".dr-card-slider__img");
    if (!img || urls.length <= 1) return;

    let i = getIndex(slider);
    i = (i - 1 + urls.length) % urls.length;
    setIndex(slider, i);
    setImg(img, urls[i]);
  }

  function initSlider(slider) {
    if (!slider || slider.__drInit) return;
    slider.__drInit = true;

    // init index by current src if possible
    const urls = parseMedia(slider);
    const img = slider.querySelector(".dr-card-slider__img");
    if (img && urls.length) {
      const src = img.getAttribute("src") || "";
      const found = urls.findIndex(u => src.includes(u) || u.includes(src));
      if (found >= 0) setIndex(slider, found);
    }

    // Swipe (works even if button click is blocked by theme)
    let sx = 0, sy = 0;

    slider.addEventListener("touchstart", (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;
      sx = t.clientX; sy = t.clientY;
    }, { passive: true });

    slider.addEventListener("touchend", (e) => {
      const t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      const dx = t.clientX - sx;
      const dy = t.clientY - sy;

      if (Math.abs(dy) > Math.abs(dx)) return; // ignore vertical scroll
      if (dx < -30) goNext(slider);
      if (dx > 30) goPrev(slider);
    }, { passive: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll(".dr-card-slider").forEach(initSlider);
  }

  // ✅ KEY FIX: CAPTURE delegation so Dawn overlay link can't steal the click
  function captureHandler(e) {
    const btn = e.target && e.target.closest ? e.target.closest(".dr-card-slider__next") : null;
    if (!btn) return;

    const slider = btn.closest(".dr-card-slider");
    if (!slider) return;

    stopAll(e);
    goNext(slider);
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAll(document);

    // capture phase listeners (strongest)
    document.addEventListener("pointerdown", captureHandler, true);
    document.addEventListener("mousedown", captureHandler, true);
    document.addEventListener("touchstart", captureHandler, { capture: true, passive: false });
    document.addEventListener("click", captureHandler, true);
  });

  // Theme editor reloads
  document.addEventListener("shopify:section:load", (e) => {
    initAll(e.target);
  });

  // If filters/infinite scroll add cards
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes || []) {
        if (node && node.querySelectorAll) initAll(node);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();